import { COLORS } from "../../../styles/constants.style";
import styled from "styled-components";

export const OverwriteFilterModalWrapper = styled.div`
  .confirm-message {
    line-height: 20px;
    margin-bottom: 8px;
    color: ${COLORS.cirrus_black10};
  }

  .item-name {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }
`;
